import type { AppRouteObject } from "../routes";
import { AddRealmRoute } from "./routes/AddRealm";

const routes: AppRouteObject[] = [AddRealmRoute];

export default routes;
